import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';

// core
import { useGlobal } from '_core/hooks/useGlobal';
import { momentLocales } from '_core/utils/momentLocales';
import { langSelectors, langActions } from '_core/store/Lang';
import { LangSwitchView } from './LangSwitchView';

const mapState = (state) => ({
  langs: langSelectors.getLangList(state),
  langId: langSelectors.getCurrentLangId(state)
});

const mapDispatch = {
  changeLang: langActions.changeLang
};

export const RawLangSwitch = (props) => {
  const { className, tooltip, inMenu, langs, langId, changeLang } = props;

  const {
    request: { queue, onFailure },
    config: { API_METHOD, DEFAULT_MOMENT_LOCALE }
  } = useGlobal();

  const [isLoading, setIsLoading] = useState(false);

  const onChange = async (newCode) => {
    // Get new language id by it's ISO code
    const code = newCode.toLowerCase();
    const newId = +Object.keys(langs).find((id) => langs[id].code === code);

    setIsLoading(true);

    try {
      // Change user language on server
      await queue(API_METHOD.LANG_CHANGE, { id: newId });

      // Change app language in store
      changeLang(newId);

      // Change `moment` locale
      momentLocales.includes(code) && (await import(`moment/locale/${code}`));
      moment.locale([code, DEFAULT_MOMENT_LOCALE]);
    } catch (error) {
      onFailure(error);
    }

    setIsLoading(false);
  };

  return (
    <LangSwitchView
      className={className}
      inMenu={inMenu}
      tooltip={tooltip}
      langs={langs}
      isLoading={isLoading}
      langId={langId}
      onChange={onChange}
    />
  );
};

RawLangSwitch.defaultProps = {};

RawLangSwitch.propTypes = {
  // self props
  inMenu: PropTypes.bool,
  tooltip: PropTypes.string,
  className: PropTypes.string,

  // `redux-connect` HOC props
  langs: PropTypes.object.isRequired,
  langId: PropTypes.number.isRequired,
  changeLang: PropTypes.func.isRequired
};

export const LangSwitch = connect(mapState, mapDispatch)(RawLangSwitch);
